import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {AbstractControl} from '@angular/forms';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {Physician} from '../../models/order-entry/physician';

@Component({
  selector: 'app-physician-selector',
  templateUrl: './physician-selector.component.html',
  styleUrls: ['./physician-selector.component.scss'],
})
export class PhysicianSelectorComponent implements OnInit, OnDestroy {
  @Input() public control: AbstractControl | null | undefined;
  @Input() public buttonMode = true;
  @Input() public label ? = 'Physician';
  @Input() public disabled = false;
  @Input() public validationGroup: string = '';
  @Input() public required ? = false;
  @Input() public patientClientId = 0;

  public isPopupVisible = false;
  public selectedPhysician?: Physician;
  private onDestroy$: Subject<void> = new Subject<void>();

  public ngOnInit() {
    this.control?.valueChanges
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(value => {
        if (value === undefined || value === null) {
          this.selectedPhysician = undefined;
        } else {
          this.selectedPhysician = value;
        }
      });
  }

  public showSearch(): void {
    this.isPopupVisible = true;
  }

  public closeDialog(physician: Physician): void {
    if (physician) {
      this.selectedPhysician = physician;
      this.control?.setValue(physician);
    }
    this.isPopupVisible = false;
  }

  public clear() {
    this.selectedPhysician = undefined;
    this.control?.setValue(null);
  }

  public get SearchPhysicianText() {
    return this.selectedPhysician ? 'Edit Physician' : 'Search Physician';
  }

  get PhysicianFullName(): string {
    return this.selectedPhysician ? `${this.selectedPhysician.lastName}, ${this.selectedPhysician.firstName}` : '';
  }

  public ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
